import { createReducer, on } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { SetAccount, SetEnvironment } from '../actions/environment.actions';

export interface EnvironmentState {
  isProd: boolean;
  account: string;
}

const initialState: EnvironmentState = {
  isProd: environment.production,
  account: environment.clientName,
};

export const EnvironmentReducer = createReducer(
  initialState,
  on(SetEnvironment, (state, { isProd }) => ({
    ...state,
    isProd,
  })),
  on(SetAccount, (state, { account }) => ({
    ...state,
    account,
  })),
);
